BaseModel = require './base_model.coffee'

class global.Notification extends BaseModel
  @ATTRIBUTES = {
    id: {}
    kind: {}
    created_at: { type: Date, default: null }
    updated_at: { type: Date, default: null }
    read_at: { type: Date, default: null }
    count: {}
    contact_name: {}
    flow_name: {}
    task_due_on: { type: Date, default: null }
    task_done_at: { type: Date, default: null }
    task_ids: {}
    metadata: {}
  }

  @ASSOCIATIONS = {
    user: -> User
  }

  @SERIALIZABLE_ASSOCIATIONS = []

  timeText: ->
    time = moment(@created_at)
    time.locale('pt-BR')
    time.fromNow()

  cssClasses: ->
    c = @kind
    c += ' read' if @read_at
    c



// WEBPACK FOOTER //
// ./src/models/notification.coffee